<template>
  <div data-app>
    <div class="row mx-0 pt-3">
      <div class="col-md-7 pl-0 row mx-0">
        <div class="col-6 py-4 px-4 border_b_silver bg-white">
          <span class="card-label font-weight-bolder Main_Blue"
            >Degree subject
          </span>
        </div>
        <div class="col-6 p-0 pt-3 text-end border_b_silver bg-white">
          <button
            type="button"
            class="custom-add-new-record-button btn_dash_ch mr-2"
            fab
            small
            @click="createFormEnable2"
          >
            <span class="v-btn__content" style="font-size: 14px !important"
              >Add new</span
            >
          </button>
        </div>
        <v-data-table
          :headers="headers2"
          :items="data2"
          item-key="job-function"
          class="elevation-1 px-4 rounded-0 headers_job_function_ch"
        >
          <template v-slot:item="props">
            <tr class="border__ch">
              <td
                class="Main_Blue"
                style="font-size: 14px; font-weight: 500 !important"
              >
                {{ props.item.subject_name }}
              </td>
              <td>
                <toggle-button
                  :value="props.item.status == '' + 1 ? true : false"
                  color="#82C7EB"
                  :sync="true"
                  :labels="false"
                  @change="changeStatus2(props.item)"
                />
                {{ props.item.status ? "Activated" : "Deactivated" }}
              </td>
              <td class="border-0" style="">
                <v-btn
                  class="py-2 ch_btn_silver_rounded_0"
                  fab
                  small
                  @click="editButtonClick2(props.item)"
                >
                  <img
                    src="\images/job_application/Edit_icon.svg"
                    alt=""
                    width="16"
                    height="16"
                  />
                </v-btn>
                <v-btn
                  class="py-2 ch_btn_silver_rounded_0"
                  fab
                  small
                  @click="askUserAboutDelete(props.item, 'subject')"
                >
                  <img
                    src="\images/job_application/Delete.svg"
                    alt=""
                    width="16"
                    height="16"
                  />
                </v-btn>
              </td>
            </tr>
            <tr>
              <td colspan="12" style="height: 12px"></td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="col-md-5 pl-0 pt-0 mt-0">
        <!-- create form start -->
        <div class="col-12 py-4 px-4 border_b_silver bg-white">
          <span
            v-if="createForm2"
            class="card-label font-weight-bolder Main_Blue"
            >Add new Degree subject
          </span>
          <span
            v-if="updateForm2"
            class="card-label font-weight-bolder Main_Blue"
            >Update Degree subject
          </span>
        </div>
        <!-- create form start -->
        <div class="col-12 bg-white p-4">
          <!-- v-if="createForm" -->
          <v-form
            ref="form"
            v-if="createForm2"
            v-model="valid2"
            lazy-validation
          >
            <v-text-field
              v-model="degree1"
              :rules="nameRules2"
              label="Degree subject"
              required
            ></v-text-field>
            <button
              type="button"
              @click="createDegree1"
              class="custom-add-new-record-button btn_dash_ch mr-2"
            >
              <span
                class="v-btn__content px-4"
                style="font-size: 14px !important"
                >Save</span
              >
            </button>
          </v-form>
          <!-- create form end -->

          <!-- update form start -->
          <v-form
            ref="form"
            v-if="updateForm2"
            v-model="valid2"
            lazy-validation
          >
            <v-text-field
              v-model="degree1"
              :rules="nameRules2"
              label="Degree subject"
              required
            ></v-text-field>
            <button
              type="button"
              @click="updateDegree1"
              class="custom-add-new-record-button btn_dash_ch mr-2"
            >
              <span
                class="v-btn__content px-4"
                style="font-size: 14px !important"
                >Update</span
              >
            </button>
            <v-btn
              style="padding: 8px !important"
              class="custom-add-new-record-button btn_red__ch"
              @click="cancel2"
            >
              Cancel
            </v-btn>
          </v-form>
          <!-- update form end -->
        </div>
      </div>
    </div>
    <!-- Confirm Delete Item -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline"
              >Do you really want to DELETE this item?</span
            >
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false"
              >No</v-btn
            >
            <v-btn class="custom-cancel-button" text @click="deleteItem"
              ><b-spinner small type="grow" v-if="deleting"></b-spinner
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/core/api";
import Swal from "sweetalert2";
import DegreeService from "@/MainServices/DegreeService.js";

export default {
  data() {
    return {
      dialog: false,
      deleteId: null,
      deleting: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      loading2: true,
      success2: false,
      valid2: true,
      createForm2: true,
      updateForm2: false,
      degree1: "",
      degree_id1: null,
      nameRules2: [
        (v) => !!v || "Degree subject is required",
        (v) =>
          (v && v.length <= 20) ||
          "Degree subject must be less than 20 characters",
      ],
      headers2: [
        { text: "Degree subject", value: "subject_name" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      data2: [],
    };
  },
  mounted() {var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    document.head.appendChild(link);
    this.getInititalData();
  },
  methods: {
    getInititalData() {
      DegreeService.getDegreeSubjects()
        .then((res) => {
          this.data2 = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    cancel2() {
      this.dialog = false;
      this.createForm2 = true;
      this.updateForm2 = false;
      this.subject_name = "";
    },
    createFormEnable2() {
      this.subject_name = "";
      this.createForm2 = true;
      this.updateForm2 = false;
    },

    createDegree1() {
      if (this.degree1 == "") {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      DegreeService.addDegreeSubjects({
        subject_name: this.degree1,
      })
        .then((res) => {
          this.loading2 = false;
          this.success2 = true;
          this.degree1 = "";
          Swal.fire({
            title: "",
            text: "Degree subject added",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel2();
        })
        .catch((error) => {
          this.loading2 = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    updateDegree1() {
      DegreeService.editDegreeSubjects(
        {
          subject_name: this.degree1,
        },
        this.degree_id1
      )
        .then((res) => {
          this.loading2 = false;
          this.success2 = true;
          this.degree1 = "";
          this.degree_id1 = "";
          Swal.fire({
            title: "",
            text: "Degree subject updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel2();
        })
        .catch((error) => {
          this.loading2 = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    changeStatus2(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .put(`${API_URL}/degree-subject/${item.id}`, {
          subject_name: item.subject_name,
          status: !item.status,
        })
        .then((res) => {
          this.loading2 = false;
          this.success2 = true;
          this.degree1 = "";
          this.degree_id1 = "";
          Swal.fire({
            title: "",
            text: "Status updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel2();
        })
        .catch(() => {
          this.loading2 = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    editButtonClick2(item) {
      this.createForm2 = false;
      this.updateForm2 = true;
      this.degree1 = item.subject_name;
      this.degree_id1 = item.id;
    },

    deleteButtonClick2(item) {
      DegreeService.deleteDegreeSubject(item)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "Degree subject deleted",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel2();
        })
        .catch(() => {
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.loading2 = false;
        });
    },

    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },

    deleteItem() {
      this.deleteButtonClick(this.deleteId);
    },
  },
};
</script>
